import FlexContainer from '@/components/atomic/atoms/layout/flex-container/styled';
import styled from '@emotion/styled';

const MenuContainer = styled(FlexContainer)(({ $paddingLeft }) => ({
	marginBlockStart: 0,
	marginBlockEnd: 0,
	paddingInlineStart: 0,
	paddingLeft: $paddingLeft,
})).withComponent('ul');

export default MenuContainer;
